import {
  TreasuryTransactionTypeEnum,
  TreasuryTransferFilterEnum,
} from '@up/data';
import { IsNumber, IsOptional, IsString } from 'class-validator';

export class TreasuryFullModuleTransferDetailRequestDto {
  @IsNumber()
  businessEntityId: number;

  @IsNumber()
  transferId: number;

  @IsString()
  @IsOptional()
  transferFilter?: TreasuryTransferFilterEnum | undefined;

  @IsNumber()
  @IsOptional()
  page?: number;

  @IsNumber()
  @IsOptional()
  limit?: number;
}
